
    import {
        computed,
        defineComponent,
        ref,
        type PropType,
    } from 'vue';
    import CheckBoxInput from '@ve/components/inputs/CheckBoxInput.vue';
    import CheckBoxInputList from '@ve/components/inputs/CheckBoxInputList.vue';
    import { RenovationType } from '@entities/hotel';

    interface RenovationOption {
        id: RenovationType;
        name: string;
    }

    const RENOVATION_OPTIONS: RenovationOption[] = [
        { id: RenovationType.RecentlyOpened, name: 'Недавно открылись' },
        { id: RenovationType.FreshRenovation, name: 'После реновации' },
    ];

    export default defineComponent({
        name: 'SerpRenovationFilter',
        components: {
            CheckBoxInput,
            CheckBoxInputList,
        },
        props: {
            allHotels: {
                type: Array as PropType<Array<{ renovationTypes: RenovationType[] }>>,
                default: () => [],
            },
            filteredHotelsWithoutRenovation: {
                type: Array as PropType<Array<{ renovationTypes: RenovationType[] }>>,
                default: () => [],
            },
            selected: {
                type: Array as PropType<RenovationType[]>,
                default: () => [],
            },
        },
        emits: ['change'],
        setup(props, { emit }) {
            const isHover = ref<RenovationType | null>(null);
            const isHoverAny = ref(false);

            const isVisible = computed(() =>
                props.allHotels.some((hotel) => hotel.renovationTypes?.length),
            );

            const isAnySelected = computed(() => props.selected.length === 0);

            const filteredCounts = computed(() => {
                return props.filteredHotelsWithoutRenovation.reduce<Record<string, number>>((acc, hotel) => {
                    if (hotel.renovationTypes?.length) {
                        hotel.renovationTypes.forEach((type) => {
                            acc[type] = (acc[type] || 0) + 1;
                        })
                    }
                    return acc;
                }, {});
            });

            const options = computed(() =>
                RENOVATION_OPTIONS.map((option) => ({
                    ...option,
                    count: filteredCounts.value[option.id] || 0,
                    disabled: !props.selected.includes(option.id) && !filteredCounts.value[option.id],
                })),
            );

            const selectAny = () => {
                emit('change', []);
            };

            const onSelectionChange = (newSelected: RenovationType[]) => {
                emit('change', newSelected);
            };

            return {
                isVisible,
                isAnySelected,
                selectAny,
                onSelectionChange,
                options,
                isHover,
                isHoverAny,
            };
        },
    });
